import { render } from "./VtoOverlay.vue?vue&type=template&id=7d5edd33"
import script from "./VtoOverlay.vue?vue&type=script&lang=js"
export * from "./VtoOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__